import React from "react";
import "./Navbar.css";
import Imagens from "../../../../components/IMAGESCOMPONENT/ImageComponent"; // ajuste o caminho da logo
import { FaInstagram, FaLinkedin, FaFacebook } from "react-icons/fa";
import { FaGlobe } from "react-icons/fa";

const NavbarBlog = () => {
  return (
    <nav className="navbarblog">
      <div className="navbarblog-left">
        <img src={Imagens.Logo} alt="Logo" className="logo" />
      </div>
      <div className="navbarblog-right">
        <a href="/" className="navbarblog-link">
  Veja Nosso Site <FaGlobe />
</a>

        <div className="social-icons">
          <a href="https://www.instagram.com/eliandroalimentos" target="_blank" rel="noopener noreferrer">
            <FaInstagram />
          </a>
          <a href="https://br.linkedin.com/company/eliandro-alimentos" target="_blank" rel="noopener noreferrer">
            <FaLinkedin />
          </a>
          <a href="https://www.facebook.com/eliandroalimentosrs/?locale=pt_BR" target="_blank" rel="noopener noreferrer">
            <FaFacebook />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default NavbarBlog;
